import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    width: '60vw',
    height: '90vh',
    backgroundColor: '#BDBDBD;',
    margin: 5,
  },
  title: {
    textAlign: 'center',
  },
});
export default useStyles;
